import { render } from "./RCBCBaseFormView.vue?vue&type=template&id=0afcdf7e&scoped=true"
import script from "./RCBCBaseFormView.vue?vue&type=script&lang=js"
export * from "./RCBCBaseFormView.vue?vue&type=script&lang=js"

import "./RCBCBaseFormView.vue?vue&type=style&index=0&id=0afcdf7e&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afcdf7e"]])

export default __exports__